export default {"src":"/_next/static/media/toothBrush_24.40a11423.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};